import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  selectedServices: {
    padding: "0 0 16px 0",
  },
  nextButton: {
    "&.MuiButton-root": {
      color: "#fff",
      background: "linear-gradient(90deg, #03228F 0%, #0E73E4 100%)",
      padding: "6px 32px !important",
      borderRadius: 999,
      fontWeight: 700,
      boxShadow: "0px 8px 16px 0px #0D72E33D",
    },
  },
  actionButton: {
    border: "1px solid #0B70E1 !important",
    color: "#0B70E1 !important",
    padding: "10px 60px !important",
  },
  serviceTable: {
    padding: 24,
    backgroundColor: "#EBF4FD",
    border: "1px solid #0B70E1",
    borderRadius: 12,
  },
  serviceRow: {
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px 0",
  },
  helperText: {
    // padding: "0 20px",
    marginTop: "15px !important",
    textTransform: "capitalize",
    color: "#637381",
    fontStyle: "italic",
  },
  animationContainer: {
    width: "100%",
    height: "100%",
    gap: 16,
    overflow: "hidden",
    zIndex: 1,
  },
  staffRow: {
    padding: "12px 16px",
    border: "1px solid #BDBDBD",
    borderRadius: 12,
    boxShadow: "0px 12px 24px -4px #919EAB29",
  },
  floatingBox: {
    position: "sticky",
    width: "fit-content",
    height: 0,
    top: "calc(100% - 82px)",
    transform: "translate(10px, 10px)",
    float: "right",
    zIndex: 9999,
    transition: "0.75s ease-in-out",
  },
  floatingButton: {
    "&.MuiButton-root": {
      color: "#fff",
      background: "linear-gradient(90deg, #03228F 0%, #0E73E4 100%)",
      width: 82,
      height: 82,
      borderRadius: "50%",
      textTransform: "inherit",
      border: "3px solid #9dc1e5",
    },
  },
}));

export { useStyles };
